import React from 'react'
import { Text, View } from 'oio-react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import UserBadgeSash from 'src/apps/People/components/UserBadgeSash'

const avatarSize = '36px'

const UserListItemTile = ({
   avatarMedia,
   badges,
   fullName,
   id,
   organization,
   position
}) => {
   const avatarUrl = avatarMedia
      ? avatarMedia?.file.thumbnailUrlW48
      : '/assets/images/avatarPlaceholder.svg'

   return (
      <Link to={`/profile/${id}`}>
         <View
            position="relative"
            width="100%"
            height={avatarSize}>
            <View
               display="block"
               float="left"
               flex="0 0 auto"
               width={avatarSize}
               height={avatarSize}
               borderRadius="3px"
               backgroundColor="#ddd"
               backgroundImage={`url(${avatarUrl})`}
               backgroundSize={avatarMedia ? 'cover' : '30px 30px'}
               backgroundPosition="bottom center"
               style={{
                  backgroundRepeat: 'no-repeat'
               }}
            />
            <View
               display="flex"
               alignItems="flex-start"
               position="absolute"
               top="0px"
               left={avatarSize}
               right="0px"
               bottom="0px"
               paddingLeft="18px">
               <View
                  float="left"
                  width="100%">
                  <Text
                     color="#222"
                     size="2"
                     weight="medium"
                     style={{
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis'
                     }}>
                     {fullName}
                  </Text>
                  {(organization || position) && (
                     <Text
                        color="#888"
                        size="1.5"
                        style={{
                           whiteSpace: 'nowrap',
                           overflow: 'hidden',
                           textOverflow: 'ellipsis'
                        }}>
                        <span>{organization}</span>
                        {organization && position && (
                           <span>, </span>
                        )}
                        <span>{position}</span>
                     </Text>
                  )}
                  <UserBadgeSash badges={badges} />
               </View>
            </View>
         </View>
      </Link>
   )
}

UserListItemTile.propTypes = {
   avatarMedia: PropTypes.object,
   badges: PropTypes.array,
   fullName: PropTypes.string.isRequired,
   id: PropTypes.string.isRequired,
   organization: PropTypes.string,
   position: PropTypes.string
}

UserListItemTile.defaultProps = {
   avatarMedia: undefined,
   badges: [],
   organization: undefined,
   position: undefined
}

export default UserListItemTile
